import React from 'react';

import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import noDataGraphV1 from 'assets/assetsV1/illustrations/newIllustrations/noDataGraphV1.svg';

import { modifyString, StringModifier } from 'constants/copyHelpers';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';

export const NoArchivedGoalsOverlayComponent = () => {
  const { moduleName } = useOrganisationSettings();

  return (
    <EmptyScreen
      heading={`You don’t have any archived ${modifyString(moduleName, StringModifier.PLURAL_SENTENCE_CASE)}`}
      description={`In case you archive a ${modifyString(
        moduleName,
        StringModifier.SENTENCE_CASE
      )}, Mesh automatically adds it to the “Archived ${modifyString(
        moduleName,
        StringModifier.PLURAL_SENTENCE_CASE
      )}” section`}
      illustrationSrc={noDataGraphV1}
      illustrationStyle={{ paddingTop: '12px', margin: '12px 0px' }}
      CTAComp={null}
    />
  );
};
